// import LegendBottom from "./LegendBottom";
import LegendLeft from './LegendLeft';
export default LegendLeft;
